<template>
  <div class="common-page driver-workforce-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="服务商名称:">
              <el-input
                style="width: 100%"
                clearable
                v-model="searchForm.companyName"
                autocomplete="off"
                placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="companyType === '1'">
            <el-form-item label="分公司:">
              <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                <el-option
                  v-for="item in belongCompanyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
              <el-button type="primary" @click="handleAdd()">添加服务商</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
          <span class="operate-btn" @click.stop="handleResetPass(row)">重置密码</span>
          <span class="operate-btn" @click.stop="handleAddRoles(row)">菜单权限</span>
          <span class="operate-btn" @click.stop="handleOpenDetail(row)">详情</span>
          <span class="operate-btn" @click.stop="handleDelete(row.companyId, '确定要删除此服务商吗')">删除</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <detail ref="detail"></detail>
    <settingPermission ref="settingPermission"></settingPermission>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import detail from "./detail.vue";
import settingPermission from "./settingPermission.vue";
import { deleteInfo, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { resetPassword } from "./api";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "ServiceManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    settingPermission,
    detail,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      searchForm: {
        companyName: "",
        belongCompanyId: "",
      },
      haveBelongCompany: true,
      orgId: [],
      departTree: [], // 部门树
      tableColumn: [
        {
          label: "服务商名称",
          prop: "companyName",
          show: true,
        },
        {
          label: "负责人姓名",
          prop: "dutyName",
          show: true,
        },
        {
          label: "负责人联系方式",
          prop: "dutyPhone",
          show: true,
        },
        {
          label: "超管账号",
          prop: "adminAccount",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "340px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    getLocalLabel,
    handleOpenDetail(row) {
      this.$refs.detail.init(row);
    },
    handleAddRoles(row) {
      this.$refs.settingPermission.init(row);
    },
    handleResetPass(row) {
      this.$confirm(`确定重置此用户密码？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        resetPassword({ companyId: row.companyId }).then((res) => {
          if (res.code === 200) {
            this.$message.success("密码重置成功");
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.driver-workforce-management {
  .search-table-box {
    display: flex;
    margin: 0 0 0.1rem;
    .list-box {
      width: 25%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;
      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }
      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }
  .custom-table-box {
    padding-top: 0;
  }
}
</style>
